export default __webpack_public_path__ + "static/media/navbar-my-account-dark.3c9e3014.svg";